export const INTERVAL_DATA_DECLINE_REASONS = [
  "Customer declined",
  "Login issues",
  "Customer security concerns",
  "Time constraints",
  "Customer moved in less than 12 months ago",
];
